module.exports = __webpack_public_path__ + "static/media/36.f7285f20.jpg";